import FSMCONSTANTS from '../../components/fseManagementSystem/utils/FSMContants';

const isUrgentBeatTeamFlow = (team = '') =>
  FSMCONSTANTS.URGENT_BEAT_ENABLED_TEAM.indexOf(team.toLowerCase().trim()) > -1;
export default isUrgentBeatTeamFlow;
